import axios from "axios";

const apiBaseUrl = process.env.REACT_APP_ASSESSMENT_SERVICE_BASE_URL;
// const apiBaseUrl = 'http://localhost:8084/product/'; 

export const getAllAssessments = () => axios.get(apiBaseUrl+'assessments');
export const getAssessmentById = (setName: any) => axios.get(apiBaseUrl+'assessment/'+setName);
export const getAssessmentBySetId = (setId: any) => axios.get(apiBaseUrl+'assessment/'+setId);
export const postAssessment = (reqBody: any) => axios.post(apiBaseUrl+'assessment', reqBody);
export const putAssessmentQuestion = (reqBody: any) => axios.put(`${apiBaseUrl}assessment/question`, reqBody);
export const putAssessmentOptions = (reqBody: any) => axios.put(`${apiBaseUrl}assessment/question/option`, reqBody);
export const putAssessmentApproveReject = (setId: number, reqBody: any) => axios.put(`${apiBaseUrl}assessment/approval/${setId}`, reqBody);
export const deleteAssessmentQuestion = (questionId: any) => axios.delete(`${apiBaseUrl}assessment/question/${questionId}`);
export const deleteAssessmentAnsweer = (answerId: any) => axios.delete(`${apiBaseUrl}assessment/question/option/${answerId}`);